"use client";

import Image from "next/image";
import { Plus } from "lucide-react";
import { ExamplePreviewLabel } from "@/components/example-preview-label";

const FOLLOWED = [
  { name: "Sarah", src: "/images/about/profiles/sarah.jpg" },
  { name: "Mike", src: "/images/about/profiles/mike.jpg" },
  { name: "Maya", src: "/images/about/profiles/maya.jpg" },
  { name: "Jordan", src: "/images/about/profiles/jordan.jpg" },
  { name: "Priya", src: "/images/about/profiles/priya.jpg" },
] as const;

const TABS = ["Home", "Following", "Tutors"] as const;

/** Static 4:3 preview of the feed following strip — invented people, not live data. */
export function FeedFollowingPreview() {
  return (
    <div
      className="relative aspect-[4/3] w-full max-w-[360px] mx-auto bg-[#f3f4f6] overflow-hidden pointer-events-none select-none"
      aria-hidden="true"
    >
      <ExamplePreviewLabel />
      <div className="absolute inset-0 flex flex-col pt-11">
        <div className="flex items-start gap-1 px-3 overflow-hidden">
          <div className="flex flex-col items-center gap-1.5 flex-shrink-0 w-[56px]">
            <div className="relative">
              <div className="rounded-full p-[2px] bg-gradient-to-br from-blue-400 to-blue-600">
                <div className="h-12 w-12 rounded-full border-[2px] border-white overflow-hidden bg-blue-50">
                  <Image
                    src="/images/about/profiles/you.jpg"
                    alt=""
                    width={48}
                    height={48}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 h-3.5 w-3.5 bg-blue-600 rounded-full border-2 border-white flex items-center justify-center z-10">
                <Plus className="h-2 w-2 text-white" strokeWidth={3} />
              </div>
            </div>
            <span className="text-[10px] font-medium text-gray-500">You+</span>
          </div>

          {FOLLOWED.map((person) => (
            <div
              key={person.name}
              className="flex flex-col items-center gap-1.5 flex-shrink-0 w-[56px]"
            >
              <div className="rounded-full p-[2px] bg-gradient-to-br from-blue-500 to-blue-600">
                <div className="h-12 w-12 rounded-full border-[2px] border-white overflow-hidden bg-blue-50">
                  <Image
                    src={person.src}
                    alt=""
                    width={48}
                    height={48}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
              <span className="text-[10px] text-gray-700 truncate w-full text-center">
                {person.name}
              </span>
            </div>
          ))}
        </div>

        <div className="flex items-center mt-2.5 px-1 border-b border-gray-200">
          {TABS.map((tab) => (
            <span
              key={tab}
              className={`relative px-3 py-1.5 text-[11px] font-medium ${
                tab === "Following" ? "text-blue-600" : "text-gray-500"
              }`}
            >
              {tab}
              {tab === "Following" && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-t" />
              )}
            </span>
          ))}
        </div>

        <div className="mx-3 mt-3 bg-white rounded-2xl border border-gray-200 shadow-sm px-3 py-2.5">
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 rounded-full overflow-hidden bg-blue-50 shrink-0">
              <Image
                src="/images/about/profiles/sarah.jpg"
                alt=""
                width={28}
                height={28}
                className="h-full w-full object-cover"
              />
            </div>
            <div className="min-w-0">
              <p className="text-[11px] font-semibold text-gray-900 truncate">
                Sarah Johnson
              </p>
            </div>
          </div>
          <p className="mt-2 text-[11px] text-gray-800 leading-snug">
            Day 127 of CompTIA Security+ studying — finally clicking.{" "}
            <span className="text-blue-600">#Security+</span>
          </p>
        </div>
      </div>
    </div>
  );
}
